import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";
import { t } from "i18next";

import cmConfigApi from "../../api/cmConfig";

import ReactTableBuilder from "../../utils/reactTableBuilder";
import { Box, Divider, IconButton } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import CmConfigForm from "./form/cmConfigForm";
import { MuiButton } from "../../components/mui";
import { StandardPage, StandardPageTopContent, StandardPageMainContent, MuiCol, MuiRow, MuiBox } from "../../components/layout";
import { MuiSelect, ScannerInput, MuiTextArea, MuiTextField, MuiCheckbox } from '../../components/inputs';

function CmConfigs(props) {
  const { t } = props;
  const [cmConfigsList, setCmConfigsList] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formValues, setFormValues] = useState({
    name:'',
    addressLabel:''
  });

  useEffect(()=>{
    loadCmConfigs();
  },
  [])

  function loadCmConfigs() {
    cmConfigApi.getCmConfigs().then((result) =>{
      if(result.data)
        setCmConfigsList(result.data);
      else
       alert("ERROR");
    });
  }

  function onFormClose() {
    setIsFormOpen(false);
  }

  function onFormOpen() {
    setIsFormOpen(true);
  }

  function onNewCmConfig() {
    setFormValues({
      cmConfigId: undefined,
      netsuiteInternalId:'',
      name:''
    });
    onFormOpen();
  }

  function onEditCmconfig(cmConfig) {
    setFormValues({
      cmConfigId:cmConfig._id,
      netsuiteInternalId:cmConfig.netsuiteInternalId,
      name:cmConfig.name
    });
    onFormOpen();
  }

  function onDeleteCmConfig(cmConfig) {
    cmConfigApi.deleteCmConfig(cmConfig._id).then(()=>{
      loadCmConfigs();
    })
    .catch((err)=>{
      alert('ERROR');
      console.log(err);
    })
  }

  function onFormSave(savedValues) {
    if(savedValues.cmConfigId){
      cmConfigApi.updateCmConfig(savedValues.cmConfigId,{
        netsuiteInternalId:savedValues.netsuiteInternalId,
        name:savedValues.name
      }).then(()=>{
        onFormClose();
        loadCmConfigs();
      })
      .catch((err)=>{
        alert('ERROR');
        console.log(err);
      })
    } else {
      cmConfigApi.addCmConfig({
        netsuiteInternalId:savedValues.netsuiteInternalId,
        name:savedValues.name
      }).then(()=>{
        onFormClose();
        loadCmConfigs();
      })
      .catch((err)=>{
        alert('ERROR');
        console.log(err);
      })
    }
  }

  const columns=[
    {
      Header: t('cm_config.name'),
      accessor: 'name',
    },
    {
      Header: t('cm_config.netsuite_cm_id'),
      accessor: 'netsuiteInternalId',
    },
    {
      Header: 'Action',
      accessor: (row, index)=>{
        return (
        <>
          <IconButton variant="contained" color="primary" aria-label="edit" onClick={()=>onEditCmconfig(row)}>
            <EditIcon />
          </IconButton>
          <IconButton variant="contained" color="error" aria-label="delete" onClick={()=>onDeleteCmConfig(row)}>
            <DeleteIcon />
          </IconButton>
        </>
        );
      },
    },
  ]

  return (
    <>
      <StandardPage
        title={t("dashboard_main.cm_config")}
      >
        <StandardPageTopContent>
          <MuiRow spacing={2} justifyContent="flex-end" sx={{marginBottom:"10px"}}>
            <MuiCol>
              <MuiButton onClick={onNewCmConfig} large startIcon={<AddIcon />}>{t('cm_config.new_cm')}</MuiButton>
            </MuiCol>
          </MuiRow>
        </StandardPageTopContent>
        <StandardPageMainContent>
          <ReactTableBuilder columns={columns} data={cmConfigsList} maxRows={9}/>
        </StandardPageMainContent>
      </StandardPage>
      <CmConfigForm isOpen={isFormOpen} onClose={onFormClose} onSave={onFormSave} values={formValues}/>
    </>
  );
}

CmConfigs.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};
const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default compose(
  withTranslation(),
  connect(
    mapStateToProps,
  )
)(CmConfigs);